export const chartTheme = {
  background: 'transparent',
  gridColor: 'rgba(255,255,255,0.04)',
  axisColor: 'rgba(255,255,255,0.15)',
  tickColor: 'rgba(255,255,255,0.4)',
  fontFamily: 'monospace',
  fontSize: 11,
  positiveColor: '#1d9e75',
  negativeColor: '#ef4444',
  neutralColor: 'rgba(255,255,255,0.6)',
  tooltipBg: '#000000',
  tooltipBorder: 'rgba(255,255,255,0.08)',
} as const;

export const chartTooltipStyle = {
  backgroundColor: chartTheme.tooltipBg,
  border: `1px solid ${chartTheme.tooltipBorder}`,
  borderRadius: '0',
  boxShadow: 'none',
  fontFamily: chartTheme.fontFamily,
  fontSize: chartTheme.fontSize,
  color: 'rgba(255,255,255,0.9)',
  padding: '8px 12px',
} as const;

export const chartAxisTick = {
  fill: chartTheme.tickColor,
  fontSize: chartTheme.fontSize,
  fontFamily: chartTheme.fontFamily,
} as const;
